import { type ToolbarProps } from 'react-big-calendar';
import { StanButton } from '@/components';
import { createIconElement } from '@/lib/utils/createIconElement';
import { AppointmentsViewToggle } from '../AppointmentsViewToggle';
import type { CalendarEvent } from '@/lib/utils/calendarUtils';
import LeftArrowSvg from '@/assets/icons/ic-arrow-left.svg';
import RightArrowSvg from '@/assets/icons/ic-arrow-right.svg';

const LeftArrowIcon = createIconElement(LeftArrowSvg);
const RightArrowIcon = createIconElement(RightArrowSvg);

interface CalendarToolbarProps extends ToolbarProps<CalendarEvent> {
    viewMode?: 'calendar' | 'list';
    onViewModeChange?: (mode: 'calendar' | 'list') => void;
}

export function CalendarToolbar({ onNavigate, label, viewMode, onViewModeChange }: CalendarToolbarProps) {
    return (
        <div className='flex flex-col-reverse gap-3 pb-3 sm:flex-row sm:items-center sm:justify-between'>
            <div className='flex items-center gap-1'>
                <StanButton
                    name='prev-month'
                    onClick={() => onNavigate('PREV')}
                    icon={LeftArrowIcon}
                    color='secondary'
                    size='sm'
                    className='!size-8 !min-w-0 !p-0'
                    variant='outline'
                />
                <span className='text-dark heading-heading3 sm:heading-heading2 px-2'>{label}</span>
                <StanButton
                    name='next-month'
                    onClick={() => onNavigate('NEXT')}
                    icon={RightArrowIcon}
                    color='secondary'
                    size='sm'
                    className='!size-8 !min-w-0 !p-0'
                    variant='outline'
                />
            </div>

            {viewMode && onViewModeChange && (
                <AppointmentsViewToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
            )}
        </div>
    );
}
